//import React from 'react';

import React, {useEffect,useState} from 'react';  
//import { Col } from 'react-bootstrap';
import { Link,useParams } from 'react-router-dom';
//import { fetchProducts } from '../../redux/slices/ProductsSlice';
//import { addToCart } from '../../redux/slices/CartSlice';
//import { addToWishList, removeFromWishList } from '../../redux/slices/AuthSlice';
// import { useDispatch,useSelector } from 'react-redux';
// import { ThunkDispatch } from '@reduxjs/toolkit';
//import { fetchAppSettings } from '../../redux/slices/SettingsSlice';
// import {Button,Modal,Form,Badge} from 'react-bootstrap'
 import paths from '../../routes/paths'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlus,faMinus } from '@fortawesome/free-solid-svg-icons';
// import { faHeart } from '@fortawesome/free-regular-svg-icons';
// import RedTShirt from '../../assets/images/tshirt/red.png'
 import CategoryFiltersLeft from './CategoryFiltersLeft'
// import ProductViewModal from './ProductViewModal'
// import LoginModal from '../Auth/LoginModal'
//import Product from './Product'

import KurtisProduct from '../Womens/Product';
import SareesProduct from './Product';
import Pagination from '../Common/Pagination'
import Spinner from '../Common/Spinner';
import MetaTags from '../Common/MetaTags';

const  SubCategories = () => {
 // const {products} = useSelector((state:any) => state.products)
  //const {colorCodes} = useSelector((state:any) => state.settings)
  //const {wishlist_ids,loggedInUser} = useSelector((state:any) => state.auth)
 // const {cart} = useSelector((state:any) => state.cart)
 // const {tShirtSettings} = useSelector((state:any) => state.settings)
  //const [selectedProduct,setSelectedProduct] = useState('' as any)
  //const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
  const [products, setProducts] =  useState<any[]>([]); //useState([]);
  //const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  // const [defaultPrice, setDefaultPrice] = useState('');
  // const [defaultStrikePrice, setDefaultStrikePrice] = useState('');
  // const {categories} = useSelector((state:any) => state.settings)
  const { categoryId } = useParams();

  //const [modalShow, setModalShow] = useState(false);
  //const [loginModalShow, setLoginModalShow] = useState(false);
  
  // useEffect(() =>{
  //   dispatch(fetchProducts());
  // },[dispatch])

 useEffect(() => {
  console.log("in use effect")
  setCurrentPage(1);
  setTotalPages(0);
 },[categoryId])
 
  useEffect(() => {
    fetchAllProducts(currentPage);
  }, [currentPage, categoryId]);

  const fetchAllProducts = async (page) => {
    setLoading(true);
    try {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + `/api/v1/products?page=${page}&per_page=40&category=${categoryId}&searchTxt=`);
      
      // Check if the response is OK (status code 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json(); // Parse the JSON data
      setProducts(data.data);
      setTotalPages(data.total_pages);
    //  setCategories(data.categories);
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setLoading(false);
    }
  };


  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0)
  };

  const searchFilters = async ( selectedSearchTxt,selectedPriceRange) => {
    setLoading(true);
    try {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + `/api/v1/products?page=${currentPage}&per_page=40&category=${categoryId}&priceRange=${selectedPriceRange}&searchTxt=${selectedSearchTxt}`);
      
      // Check if the response is OK (status code 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json(); // Parse the JSON data
      setProducts(data.data);
      setTotalPages(data.total_pages);

    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setLoading(false);
    }
  } 
console.log("product['subcategory']",products)
  return (
    <>
      <MetaTags
        title={products[0]?.['sub_subcategory']['meta_title']}
        description={products[0]?.['sub_subcategory']['meta_description']}
        url={"https://www.anuughacollections.com/" + products[0]?.['sub_subcategory']['slug']}
        image={process.env.REACT_APP_SERVER_URL + ( products[0]?.variants[0].variant_images[0]?.display_image_url)}
      />
      <div className="page-content bg-light">

        <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG" >
          <div className="container">
            <div className="dz-bnr-inr-entry">
              <h1>{categoryId}</h1>
              <nav aria-label="breadcrumb" className="breadcrumb-row">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to={paths.store} className=" menu-title ">Home</Link></li>
                  <li className="breadcrumb-item">{categoryId}</li>
                </ul>
              </nav>
            </div>
          </div>	
        </div>

        <section className="content-inner-3 pt-3 z-index-unset">
          <div className="container-fluid">
            <div className="row">
                <CategoryFiltersLeft searchFilters={searchFilters}/>
                <div className="col-80 col-xl-9">
                <div className="row">
                  <div className="col-12 tab-content shop-" id="pills-tabContent">
                    <div className="tab-pane fade active show" id="tab-list-grid" role="tabpanel" aria-labelledby="tab-list-grid-btn">
                      {loading ? (
                        <Spinner/>
                      ) : (
                            <div className="row gx-xl-4 g-3">
                              {products && products.map((product,index) => 
                                <>
                                      {product['subcategory']['name'] === "Sarees" && <SareesProduct product={product} index={index} key={index} />} 
                                      {product['subcategory']['name'] !== "Sarees" && <KurtisProduct product={product} index={index} key={index} /> }
                                  </>
                              )}
                            
                            </div>
                          )}
                    </div>
                  </div>
                </div>
                
                {!loading && 
                  <div className="row page mt-0">
                    <div className="col-md-6">
                      <p className="page-text">Showing {currentPage} Of {totalPages} Results</p>
                    </div>
                    <div className="col-md-6">
                  
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                          />
                        
                          {products.length === 0 && 
                                
                                <div className="col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 m-md-b15 m-b30">
                                    <div className="shop-card style-1">No Products.</div>
                                </div>
                              }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </section> 
        {/* {selectedProduct  && <ProductViewModal selectedProduct={selectedProduct} modalShow={modalShow} onClose={handleModalClose} wishListData={manageWishList} wishlistIds={wishlist_ids}/>}
        {loginModalShow && <LoginModal modalShow={loginModalShow} onClose={handleLoginModalClose} />}
        */}
      </div> 
    </>
  );
}

export default SubCategories;

 
